import React from "react";
import styles from "./ItemCard.module.css";
import CardButton from "./CardButton";

function ItemCard(props) {
  const [isDisabled, setIsDisabled] = React.useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.imgPrice}>
        <img src={props.img} width="220" height="150" alt="Блюдо" />
      </div>
      <div className={styles.infoBlockCard}>
        <div className={styles.title}>
          <h3 className={styles.h3}>{props.name}</h3>
          <div className={styles.description}>
            <div className={styles.descriptionP}>
              <p className={styles.p}>{props.description}</p>
            </div>
          </div>
        </div>
        <div className={styles.price}>
          <span>{props.weight}</span>
          <h1>{props.price} ₽</h1>
        </div>
      </div>
      <div className={styles.button}>
        <CardButton
          date={props}
          isDisabled={isDisabled}
          addressCity={props.addressCity}
          souse={props.souse}
        />
      </div>
    </div>
  );
}

export default ItemCard;
